// assets
import { MonitorOutlined, SlidersOutlined, AlertOutlined } from '@ant-design/icons';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
// icons
const icons = {
  MonitorOutlined,
  SlidersOutlined,
  AlertOutlined,
  AnalyticsOutlinedIcon
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const realtime = {
  id: 'group-realtime',
  title: '발전소 현황',
  type: 'group',
  admin: false,
  outeradmin: false,
  children: [
    {
      id: 'realtime',
      title: '발전 현황',
      type: 'item',
      admin: false,
      url: '/realtime/default',
      icon: icons.MonitorOutlined,
      breadcrumbs: false
    },

    {
      id: 'realtime-device',
      title: '장치별 현황',
      type: 'item',
      url: '/realtime/device',
      icon: icons.SlidersOutlined,
      breadcrumbs: false
    },

    {
      id: 'realtime-joinbox',
      title: '접속반 현황',
      type: 'item',
      url: '/realtime/joinbox',
      icon: icons.SlidersOutlined,
      breadcrumbs: false
    },

    {
      id: 'realtime-alert',
      title: '알림 현황',
      type: 'item',
      url: '/realtime/alert',
      icon: icons.AlertOutlined,
      breadcrumbs: false
    }
  ]
};

export default realtime;
